export default __webpack_public_path__ + "static/media/px.275a2520.png";